import { render, staticRenderFns } from "./download.vue?vue&type=template&id=e4919f14&scoped=true"
import script from "./download.vue?vue&type=script&lang=ts"
export * from "./download.vue?vue&type=script&lang=ts"
import style0 from "./download.vue?vue&type=style&index=0&id=e4919f14&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4919f14",
  null
  
)

export default component.exports